module.exports = __webpack_public_path__ + "static/media/preciouscontrol.ec6bc31a.png";